import './tripsList.css';
import {NavLink} from "react-router-dom";
const TripsList = ({data, classes}) => {
    return(
        <div className={`data-table trips-list-table ${classes}`}>
            <ul className="table-row sf-medium table-header light-back border-radius-8">
                <li className={'from'}>From</li>
                <li className={'to'}>To</li>
                <li className={'distance'}>Distance</li>
                <li className={'duration'}>Duration</li>
                {/*<li className={'fuel-consumed'}>Fuel Consumed</li>*/}
                <li className={'alerts'}>Alerts</li>
                <li className={'date-time'}>Date & Time</li>
                <li className={'score'}>Score</li>
                <li className={'number-plate'}>Vehicle Plate No</li>
            </ul>
            {
                data.map((trip) =>
                    <ul key={trip} className="table-row padding-tb-10 sf-medium border-bottom">
                        <li className={'from'}>
                            <NavLink to={`${trip}`} className="highlight-color">Chennai</NavLink>
                        </li>
                        <li className={'to'}>
                            <NavLink to={`${trip}`} className="highlight-color">Madurai</NavLink>
                        </li>
                        <li className={'distance'}>380 Kms</li>
                        <li className={'duration'}>4.5 Hrs</li>
                        {/*<li className={'fuel-consumed'}>80 Ltrs</li>*/}
                        <li className={'alerts'}>38</li>
                        <li className={'date-time'}>Aug 28  9:36 - Aug 29 13:05</li>
                        <li className={'date-time flex'}>
                            <div className="progress-bar item-height-6 width-60">
                                <div className="completed"></div>
                            </div>
                            <div className="margin-l-10">4.8</div>
                        </li>
                        <li className={'number-plate'}>KA 05 HR 3789</li>
                    </ul>
                )
            }
        </div>
    )
}

export default TripsList;
